import { FC } from "react"
import { useSearchParams } from "react-router"
import { AccessDenied as AccessDeniedComponent } from "~/components/AccessDenied"
import { Footer } from "~/components/Footer"
import { Header } from "~/components/Header"
import { useAuthActions, useAuthState } from "~/context/auth"
import { APPLICATION_BASE } from "~/router"
import { getLocation } from "~/utils"

export enum AccessDeniedQueryParams {
  RedirectUrl = "redirectUrl",
}

export const AccessDenied: FC = () => {
  const [searchParams] = useSearchParams()
  const { user } = useAuthState()
  const { logout } = useAuthActions()

  if (!user) {
    // This page required authentication and should be used inside validated auth context
    console.error("Developer error. Missing expected authenticated user data.")
    return null
  }

  const userFullName = user ? `${user.firstname} ${user.lastname}`.trim() : ""
  const redirectUrl = searchParams.get(AccessDeniedQueryParams.RedirectUrl) || undefined

  const handleLogout = () => {
    const applicationBaseUrl = `${getLocation().origin}${APPLICATION_BASE}/`
    logout({ redirectUrl: redirectUrl || applicationBaseUrl })
  }

  return (
    <div className="flex h-screen flex-col">
      <Header logout={handleLogout} userEmail={user?.email} userFullName={userFullName} />
      <AccessDeniedComponent className="grow" logout={handleLogout} userEmail={user.email} />
      <Footer />
    </div>
  )
}
